import React, {useEffect, useState} from 'react';
import PropTypes from 'prop-types';
import cn from 'classnames';

import styles from './SwitchButtons.module.scss';

export const SwitchButtons = ({buttons, current, onClick}) => {
  const [active, setActive] = useState(current || buttons[0].value);

  const handleClick = value => {
    setActive(value);
    onClick(value);
  };

  useEffect(() => {
    setActive(current);
  }, [current]);

  return (
    <div className={styles.wrap}>
      {buttons.map(item => (
        <div
          key={item.value}
          className={cn(styles.button, {
            [styles.active]: active === item.value,
          })}
          onClick={() => handleClick(item.value)}
        >
          {item.label}
        </div>
      ))}
    </div>
  );
};

SwitchButtons.propTypes = {
  buttons: PropTypes.arrayOf(
    PropTypes.shape({
      value: PropTypes.string.isRequired,
      label: PropTypes.node.isRequired,
    }),
  ).isRequired,
  current: PropTypes.string,
  onClick: PropTypes.func,
};

SwitchButtons.defaultProps = {
  current: null,
  onClick: () => null,
};
